var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',_vm._l((_vm.questionBoard.questionGroups),function(item){return (item.visible)?_c('QuestionGroupView',{staticClass:"container-questions",attrs:{"group":item},on:{"toggle":_vm.onToggleGroup}}):_vm._e()}),1)}
var staticRenderFns = []

export { render, staticRenderFns }